import {ISlidePreview} from '../incase-domain/proptypes/slidePreview';
import {appendSlidePreviewCacheBust} from './slidePreviewUrl';

function previewRevision(preview: ISlidePreview | undefined): number {
    return preview?.revision ?? 0;
}

function isNewerSlidePreview(incoming: ISlidePreview, existing: ISlidePreview | undefined): boolean {
    if (!existing) {
        return true;
    }
    const incomingRevision = previewRevision(incoming);
    const existingRevision = previewRevision(existing);
    if (!incomingRevision || !existingRevision) {
        return true;
    }
    return incomingRevision >= existingRevision;
}

export function withSlidePreviewCacheBust(preview: ISlidePreview): ISlidePreview {
    return {
        ...preview,
        imgSrc: appendSlidePreviewCacheBust(preview.imgSrc, preview.revision ?? Date.now()),
    };
}

export function mergeSlidePreviewIntoList(previews: ISlidePreview[], incoming: ISlidePreview): ISlidePreview[] {
    if (!incoming?.slideId || !incoming.imgSrc) {
        return previews;
    }
    const index = previews.findIndex((preview) => String(preview.slideId) === String(incoming.slideId));
    if (index < 0) {
        return [...previews, incoming];
    }
    const existing = previews[index];
    if (existing.imgSrc === incoming.imgSrc && !isNewerSlidePreview(incoming, existing)) {
        return previews;
    }
    const next = [...previews];
    next[index] = incoming;
    return next;
}

export function mergeSlidePreviewLists(current: ISlidePreview[], incoming: ISlidePreview[]): ISlidePreview[] {
    return incoming.reduce((previews, preview) => mergeSlidePreviewIntoList(previews, preview), current);
}
